import { AffiliateRevenueSnapshot } from '@libs/shared/interfaces/timestream.interface';

export interface AffiliateCompany {
  companyId: number;
  expiresAt: Date;
  companyName: string;
}

export type DBAffiliate = {
  feeShare: number;
  referralLink: string;
  summaryStats: {
    totalRevenue: SummaryStat,
    linkClicks: SummaryStat,
    registrations: SummaryStat,
    firstTimeDepositors: SummaryStat,
    totalTradingVolume: SummaryStat,
    totalFees: SummaryStat,
  };
  trendStats: {
    totalRevenue?: ChartStat[],
    linkClicks?: ChartStat[],
    registrations?: ChartStat[],
    firstTimeDepositors?: ChartStat[],
    totalTradingVolume?: ChartStat[],
    totalFees?: ChartStat[],
  }
};

export interface ConvertedAffiliateState {
  date: number,
  totalRevenue: number,
  linkClicks: number,
  registrations: number,
  firstTimeDepositors: number,
  totalTradingVolume: number,
  totalFees: number,
}

export interface SummaryStat {
  value: number; 
  trend: number
}

export interface ChartStat {
  value: number; 
  time: number
}

export enum AffiliateStats {
  totalRevenue = "totalRevenue", 
  linkClicks = "linkClicks", 
  registrations = "registrations", 
  firstTimeDepositors = "firstTimeDepositors", 
  totalTradingVolume = "totalTradingVolume", 
  totalFees = "totalFees"
}

export enum AffiliateTime {
  last_7_days = "last_7_days",
  last_30_days = "last_30_days",
  last_year = "last_year",
}

export const AffiliateStatsTitle = {
  [AffiliateStats.totalRevenue]: "affiliates.your_earnings", 
  [AffiliateStats.linkClicks]: "affiliates.link_clicks", 
  [AffiliateStats.registrations]: "affiliates.registrations", 
  [AffiliateStats.firstTimeDepositors]: "affiliates.total_depositors", 
  [AffiliateStats.totalTradingVolume]: "affiliates.referral_trading_vol", 
  [AffiliateStats.totalFees]: "affiliates.total_fees"
}

export const affiliateTimeDropdowm = {
  [AffiliateTime.last_7_days]: "affiliates.7_days",
  [AffiliateTime.last_30_days]: "affiliates.30_days",
  [AffiliateTime.last_year]: "affiliates.year_days",
}

export enum AffDashboardVisibilitySettingEnum {
  DISABLED = 'disabled',
  ENABLED_FOR_ALL = 'enabled for all',
  ENABLED_FOR_AFFILIATES = 'enabled for affiliates',
}
